(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  // Dynamic overflow detection for desktop navigation row
  class HeaderNavRowOverflow {
    constructor() {
      this.container = document.querySelector('.header__navigation-row');
      if (!this.container) return;
      this.init();
    }

    init() {
      this.calculateOverflow = this.calculateOverflow.bind(this);
      
      // Wait for fonts & layout
      if (document.fonts) {
        document.fonts.ready.then(() => {
          this.calculateOverflow();
        });
      }
      window.requestAnimationFrame(() => {
        setTimeout(this.calculateOverflow, 100);
      });
      window.addEventListener('resize', this.debounce(this.calculateOverflow, 100));
    }

    debounce(fn, delay) {
      let timer;
      return function (...args) {
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, args), delay);
      };
    }

    calculateOverflow() {
      if (window.innerWidth < 990) return;
      const innerContainer = this.container.querySelector('.header__navigation-row-inner');
      const nav = this.container.querySelector('.header__inline-menu');
      const list = nav ? nav.querySelector('.list-menu--inline') : null;
      if (!list || !innerContainer) return;

      // 1. Reset any previous overflow elements back to main list
      let moreLi = list.querySelector('.header__menu-item-more-container');
      if (moreLi) {
        const movedItems = Array.from(moreLi.querySelectorAll('.header__submenu > li'));
        movedItems.forEach((li) => {
          list.insertBefore(li, moreLi);
        });
        moreLi.remove();
      }

      // 2. Unhide all items
      const items = Array.from(list.children);
      items.forEach((item) => {
        item.style.display = '';
      });

      // 3. Measure available width — from inner container's padded left edge to right edge
      const containerRect = innerContainer.getBoundingClientRect();
      const computedStyle = window.getComputedStyle(innerContainer);
      const paddingLeft = parseFloat(computedStyle.paddingLeft) || 0;
      const paddingRight = parseFloat(computedStyle.paddingRight) || 0;
      const maxAllowedRight = containerRect.right - paddingRight;
      const MORE_BUTTON_WIDTH = 120; // width of MORE trigger button with arrow

      let firstOverflowIdx = -1;

      // Check each item's actual rendered boundary
      for (let i = 0; i < items.length; i++) {
        const itemRect = items[i].getBoundingClientRect();
        // If this item extends beyond allowed right edge (accounting for More button if needed)
        if (itemRect.right > maxAllowedRight - MORE_BUTTON_WIDTH && i < items.length - 1) {
          firstOverflowIdx = i;
          break;
        } else if (itemRect.right > maxAllowedRight) {
          firstOverflowIdx = i;
          break;
        }
      }

      if (firstOverflowIdx !== -1) {
        const overflowItems = items.slice(firstOverflowIdx);

        const moreContainer = document.createElement('li');
        moreContainer.className = 'header__menu-item-more-container';
        moreContainer.innerHTML = `
          <header-menu>
            <details id="Details-HeaderMenu-More" class="disclosure-has-popup">
              <summary
                id="HeaderMenu-More"
                class="header__menu-item header__menu-item--more list-menu__item link focus-inset"
                aria-expanded="false"
                aria-haspopup="true"
                role="button"
                tabindex="0"
              >
                <span>More</span>
                <span class="svg-wrapper" style="display:inline-flex;align-items:center;margin-left:0.6rem;">
                  <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6" style="width:10px;height:6px;">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
                  </path></svg>
                </span>
              </summary>
              <ul
                id="HeaderMenu-MenuList-More"
                class="header__submenu list-menu list-menu--disclosure motion-reduce"
                role="menu"
                tabindex="-1"
                aria-labelledby="HeaderMenu-More"
              >
              </ul>
            </details>
          </header-menu>
        `;

        const submenuUl = moreContainer.querySelector('.header__submenu');
        overflowItems.forEach((item) => {
          const mainLink = item.querySelector('a');
          const summaryEl = item.querySelector('summary');
          const li = document.createElement('li');
          li.setAttribute('role', 'none');

          if (mainLink) {
            const clone = mainLink.cloneNode(true);
            clone.className = 'header__menu-item list-menu__item link';
            clone.setAttribute('role', 'menuitem');
            li.appendChild(clone);
          } else if (summaryEl) {
            const spanText = summaryEl.querySelector('span')?.textContent?.trim() || summaryEl.textContent.trim();
            const anchor = document.createElement('a');
            anchor.href = '#';
            anchor.className = 'header__menu-item list-menu__item link';
            anchor.textContent = spanText;
            anchor.setAttribute('role', 'menuitem');
            li.appendChild(anchor);
          }
          submenuUl.appendChild(li);
          item.remove(); // remove original from top row
        });

        list.appendChild(moreContainer);

        const details = moreContainer.querySelector('details');
        const summary = moreContainer.querySelector('summary');

        // Allow click navigation on submenu links
        submenuUl.addEventListener('click', (e) => {
          const clickedLink = e.target.closest('a');
          if (clickedLink && clickedLink.href && clickedLink.getAttribute('href') !== '#') {
            details.removeAttribute('open');
            summary.setAttribute('aria-expanded', 'false');
            window.location.href = clickedLink.href;
          }
        });

        // Accessible aria-expanded sync
        details.addEventListener('toggle', () => {
          summary.setAttribute('aria-expanded', details.hasAttribute('open') ? 'true' : 'false');
        });

        // Close on Escape key
        moreContainer.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && details.hasAttribute('open')) {
            details.removeAttribute('open');
            summary.setAttribute('aria-expanded', 'false');
            summary.focus();
          }
        });

        // Close when clicking outside
        document.addEventListener('click', (e) => {
          if (!moreContainer.contains(e.target) && details.hasAttribute('open')) {
            details.removeAttribute('open');
            summary.setAttribute('aria-expanded', 'false');
          }
        });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new HeaderNavRowOverflow());
  } else {
    new HeaderNavRowOverflow();
  }

  } catch(e) { console.error(e); }
})();
})();
